import {GetBrowseUSPsResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/browse_page/v1/service.types';
import {COLORS, InfiniteSlider, Usp} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const UspsView: React.FC<
  GetBrowseUSPsResponse & {className?: string}
> = ({className, usps}) => {
  return (
    <InfiniteSlider
      className={className}
      items={usps}
      SlideComponent={({item: usp}) => (
        <StyledUsp
          key={usp.label}
          text={usp.label}
          image={usp.image}
          href={usp.href}
        />
      )}
    />
  );
};

const StyledUsp = styled(Usp)`
  &&& {
    justify-content: center;
    flex-shrink: 0;
    flex-basis: calc(100%);
    padding: 10px 0;
    background-color: transparent;
    color: ${COLORS.Black};
  }
`;
